import React from 'react';
import Software from './Software';
import Navbar from '../../../../examples/Navigation/Navbar.jsx'; 
// import Hero from './CPHero';
import Footer from '../../../../examples/Footers/Footer/footer.jsx'; 

function SoftwareWrapper() {
  return (
    <>
      <Navbar />
      {/* <Hero /> */}
      <Software />
      <Footer />
    </>
  );
}

export default SoftwareWrapper;
